import React from "react";
import PropTypes from "prop-types";
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";
import NumberFormat from "react-number-format";
import Switch from "@material-ui/core/Switch";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import Input from "@material-ui/core/Input";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import FormHelperText from "@material-ui/core/FormHelperText";

const useStyles = makeStyles(theme => ({
  SwitchLabel: {
    "& .MuiFormControlLabel-label": {
      fontSize: "0.75rem"
    }
  },
  SwitchLabelNoPadding: {
    "& .MuiFormControlLabel-labelPlacementTop": {}
  },
  formControl: {
    minWidth: 120,
    maxWidth: 250,
    margin: "0px",
    marginTop: "16px",
    marginRight: "16px"
  },
  typography: {
    color: "rgba(0, 0, 0, 0.54)",
    padding: 0,
    fontSize: "1rem",
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    fontWeight: 400,
    lineHeight: 1,
    transform: "translate(0, 1.5px) scale(0.75)",
    transformOrigin: "top left",
    letterSpacing: "0.00938em",
    transition:
      "color 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms,transform 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms"
  }
}));

const CommercialData = ({
  type,
  onChange,
  disabled,
  value,
  error,
  children,
  title,
  commercial_data,
  invoice_types,
  payment_deals,
  payment_methods,
  currency_types,
  banks,
  ...props
}) => {
  const handleChange = event => {
    onChange(event, "commercial_data");
  };
  const theme = useTheme();
  const classes = useStyles();
  return (
    <React.Fragment>
      <Typography variant="h6" className="mt-2">
        {title}
      </Typography>
      <NumberFormat
        placeholder="Ingrese el rebate"
        label="Rebate"
        disabled={disabled}
        id="rebate"
        name="rebate"
        className="mt-3 mr-2"
        InputProps={{ style: { minWidth: 100, fontSize: "0.75rem" } }}
        value={commercial_data.rebate !== "0" ? commercial_data.rebate : null}
        //value={commercial_data.rebate}
        onChange={handleChange}
        decimalSeparator="."
        prefix={"%"}
        allowEmptyFormatting={true}
        customInput={TextField}
        InputLabelProps={{
          shrink: true
        }}
        isAllowed={values => {
          let { floatValue } = values;
          floatValue = floatValue !== undefined ? floatValue : 0;
          return floatValue >= 0 && floatValue <= 100;
        }}
      />

      {/*      <TextField
        id="payment_deadline"
        disabled={disabled}
        name="payment_deadline"
        type="number"
        label="Plazo de pago en días"
        placeholder="Ingrese el plazo de pago"
        onChange={handleChange}
        value={commercial_data.payment_deadline}
        margin="normal"
        className="mr-2 "
        InputLabelProps={{
          shrink: true,
        }}
        inputProps={{min: "0", style:{minWidth: 200, fontSize: '0.75rem'}}}
      />
*/}

      <FormControl
        className={classes.formControl}
        inputProps={{ shrink: true }}
      >
        <Typography className={classes.typography}>Término de pago</Typography>
        <Select
          native
          name="payment_deadline"
          inputProps={{
            name: "payment_deadline",
            className: "payment_deadline"
          }}
          style={{ minWidth: 150, fontSize: "0.75rem" }}
          onChange={handleChange}
          disabled={disabled}
          value={commercial_data.payment_deadline}
          input={<Input id="grouped-native-select" name={"payment_deadline"} />}
        >
          <option value="" label="Seleccione" />
          {payment_deals.map(payment_deal => (
            <option id={payment_deal.name} value={payment_deal.name}>
              {payment_deal.name}
            </option>
          ))}
        </Select>
      </FormControl>

      <FormControl
        className={classes.formControl}
        inputProps={{ shrink: true }}
      >
        <Typography className={classes.typography}>
          Método de pago preferido
        </Typography>
        <Select
          native
          name="payment_method"
          inputProps={{
            name: "payment_method",
            className: "payment_method"
          }}
          style={{ minWidth: 150, fontSize: "0.75rem" }}
          onChange={handleChange}
          disabled={disabled}
          value={commercial_data.payment_method}
          input={<Input id="grouped-native-select" name={"payment_method"} />}
        >
          <option value="" label="Seleccione" />
          {payment_methods.map(payment_method => (
            <option id={payment_method.id} value={payment_method.name}>
              {payment_method.name}
            </option>
          ))}
        </Select>
      </FormControl>

      <NumberFormat
        disabled={disabled}
        placeholder="Ingrese la clasificacion"
        label="Clasificacion SGO"
        name="classification"
        className="mt-3 mr-2"
        InputProps={{ style: { minWidth: 100, fontSize: "0.75rem" } }}
        value={commercial_data.classification}
        onChange={handleChange}
        decimalSeparator="."
        decimalScale={2}
        //            fixedDecimalScale={true}
        customInput={TextField}
        InputLabelProps={{
          shrink: true
        }}
        isAllowed={values => {
          let { floatValue } = values;
          floatValue = floatValue !== undefined ? floatValue : 0;
          return floatValue >= 0 && floatValue <= 100;
        }}
      />

      <FormControlLabel
        className={classes.SwitchLabel}
        style={{
          marginBottom: 0,
          marginTop: "16px",
          marginRight: "8px",
          marginLeft: 0
        }}
        control={
          <Switch
            id="commercial_data.discount_in_vouchers"
            disabled={disabled}
            value={commercial_data.discount_in_vouchers}
            checked={commercial_data.discount_in_vouchers}
            name="discount_in_vouchers"
            onChange={handleChange}
            size="small"
            color="primary"
            className=""
          />
        }
        label="Descuento en Factura?"
        labelPlacement="top"
      />

      <NumberFormat
        disabled={disabled}
        placeholder="Ingrese los descuentos"
        label="Descuentos"
        name="discount"
        className="mt-3 mr-2"
        InputProps={{ style: { minWidth: 100, fontSize: "0.75rem" } }}
        value={
          commercial_data.discount !== "0" ? commercial_data.discount : null
        }
        //            value={commercial_data.discount}
        onChange={handleChange}
        decimalSeparator="."
        prefix={"%"}
        customInput={TextField}
        InputLabelProps={{
          shrink: true
        }}
        isAllowed={values => {
          let { floatValue } = values;
          floatValue = floatValue !== undefined ? floatValue : 0;
          return floatValue >= 0 && floatValue <= 100;
        }}
      />
      <NumberFormat
        disabled={disabled}
        placeholder="Ingrese el limite de crédito"
        label="Limite de crédito"
        name="credit_limit"
        className="mt-3 mr-2"
        InputProps={{ style: { minWidth: 100, fontSize: "0.75rem" } }}
        value={
          commercial_data.credit_limit !== "0"
            ? commercial_data.credit_limit
            : null
        }
        //            value={commercial_data.credit_limit}
        onChange={handleChange}
        thousandSeparator="."
        decimalSeparator=","
        prefix={"$"}
        customInput={TextField}
        InputLabelProps={{
          shrink: true
        }}
        isAllowed={values => {
          let { floatValue } = values;
          floatValue = floatValue !== undefined ? floatValue : 0;
          return floatValue >= 0;
        }}
      />
      <FormControl
        required
        className={classes.formControl}
        inputProps={{ shrink: true }}
      >
        <Typography className={classes.typography}>Tipo de factura</Typography>
        <Select
          native
          name="invoice_type_id"
          inputProps={{
            name: "invoice_type_id",
            className: "invoice_type_id"
          }}
          style={{ minWidth: 150, fontSize: "0.75rem" }}
          disabled={disabled}
          onChange={handleChange}
          required
          error={
            error !== "" && commercial_data.invoice_type_id === ""
              ? "Debe completar este campo"
              : false
          }
          value={commercial_data.invoice_type_id}
          input={<Input id="grouped-native-select" name="invoice_type_id" />}
        >
          <option value="" label="Seleccione" />
          {invoice_types.map(invoice_type => (
            <option id={invoice_type.id} value={invoice_type.id}>
              {invoice_type.name}
            </option>
          ))}
        </Select>
        {error !== "" && commercial_data.invoice_type_id === "" && (
          <FormHelperText style={{ color: "red" }}>
            Debe completar este campo
          </FormHelperText>
        )}
      </FormControl>
      <FormControl
        required
        className={classes.formControl}
        inputProps={{ shrink: true }}
      >
        <Typography className={classes.typography}>Moneda</Typography>
        <Select
          native
          name="currency"
          inputProps={{
            name: "currency",
            className: "currency"
          }}
          style={{ minWidth: 150, fontSize: "0.75rem" }}
          disabled={disabled}
          onChange={handleChange}
          required
          value={commercial_data.currency}
          input={<Input id="grouped-native-select" name="invoice_type_id" />}
        >
          <option value="" label="Seleccione" />
          {currency_types.map(currency_type => (
            <option id={currency_type.id} value={currency_type.id}>
              {currency_type.name}
            </option>
          ))}
        </Select>
      </FormControl>
      <TextField
        id="cost_account"
        name="cost_account"
        label="Cta. Costo"
        disabled={disabled}
        type="text"
        placeholder="Ingrese la cuenta costo"
        onChange={handleChange}
        value={commercial_data.cost_account}
        margin="normal"
        className="mr-2 "
        InputLabelProps={{
          shrink: true
        }}
        inputProps={{ style: { minWidth: 200, fontSize: "0.75rem" } }}
      />
      <TextField
        id="cbu"
        name="cbu"
        label="CBU"
        disabled={disabled}
        type="text"
        placeholder="Ingrese el cbu"
        onChange={handleChange}
        value={commercial_data.cbu}
        margin="normal"
        className="mr-2 "
        InputLabelProps={{
          shrink: true
        }}
        inputProps={{ style: { minWidth: 200, fontSize: "0.75rem" } }}
      />
      <FormControl
        className={classes.formControl}
        inputProps={{ shrink: true }}
      >
        <Typography className={classes.typography}>Banco</Typography>
        <Select
          native
          name="bank_id"
          inputProps={{
            name: "bank_id",
            className: "bank_id"
          }}
          style={{ minWidth: 150, fontSize: "0.75rem" }}
          onChange={handleChange}
          disabled={disabled}
          value={commercial_data.bank_id}
          input={<Input id="grouped-native-select" name={"bank_id"} />}
        >
          <option value="" label="Seleccione" />
          {banks.map(payment_deal => (
            <option id={payment_deal.id} value={payment_deal.id}>
              {payment_deal.name}
            </option>
          ))}
        </Select>
      </FormControl>

      <TextField
        id="bank_account_number"
        name="bank_account_number"
        label="Cuenta bancaria"
        disabled={disabled}
        type="text"
        placeholder="Ingrese la cuenta bancaria"
        onChange={handleChange}
        value={commercial_data.bank_account_number}
        margin="normal"
        className="mr-2 "
        InputLabelProps={{
          shrink: true
        }}
        inputProps={{ style: { minWidth: 200, fontSize: "0.75rem" } }}
      />
      <TextField
        id="bank_branch"
        name="bank_branch"
        label="Sucursal bancaria"
        disabled={disabled}
        type="text"
        placeholder="Ingrese la sucursal bancaria"
        onChange={handleChange}
        value={commercial_data.bank_branch}
        margin="normal"
        className="mr-2 "
        InputLabelProps={{
          shrink: true
        }}
        inputProps={{ style: { minWidth: 200, fontSize: "0.75rem" } }}
      />
      <div className="row">
        <FormControlLabel
          className={classes.SwitchLabel}
          control={
            <Switch
              id="commercial_data.has_deposit_account"
              disabled={disabled}
              value={commercial_data.has_deposit_account}
              checked={commercial_data.has_deposit_account}
              name="has_deposit_account"
              onChange={handleChange}
              size="small"
              color="primary"
              className="mr-2"
            />
          }
          label="Tiene cuenta corriente?"
          labelPlacement="start"
        />

        <FormControlLabel
          className={classes.SwitchLabel}
          control={
            <Switch
              id="commercial_data.allow_advance"
              disabled={disabled}
              value={commercial_data.allow_advance}
              checked={commercial_data.allow_advance}
              name="allow_advance"
              onChange={handleChange}
              size="small"
              color="primary"
              className="mr-2"
            />
          }
          label="Requiere adelanto?"
          labelPlacement="start"
        />
      </div>
    </React.Fragment>
  );
};

CommercialData.defaultProps = {
  type: "text",
  className: "",
  disabled: false
};

CommercialData.propTypes = {
  name: PropTypes.string.isRequired,
  type: PropTypes.string,
  placeholder: PropTypes.string.isRequired,
  className: PropTypes.string,
  value: PropTypes.any,
  onChange: PropTypes.func.isRequired
};

export default CommercialData;
